import React, { useEffect, useState } from 'react';

import { css } from '@emotion/react';
import { ErrorMessage } from '@hookform/error-message';
import { useDaumPostcodePopup } from 'react-daum-postcode';
import { FieldErrors, useController } from 'react-hook-form';

import { palette } from '@styles/theme';

interface Props {
  name: string;
  rules: any;
  errors: FieldErrors;
  control: any;
}

const Postcode = ({ name, rules, errors, control }: Props) => {
  const open = useDaumPostcodePopup();
  const { field } = useController({
    control: control,
    name: name,
    rules: rules,
  });
  const [value, setValue] = useState(String(field.value));

  const handleComplete = (data: any) => {
    let fullAddress = data.address;
    let extraAddress = '';

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress +=
          extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
    }

    setValue(fullAddress);
    field.onChange(fullAddress);
  };

  const handleClick = () => {
    open({ onComplete: handleComplete });
  };

  useEffect(() => {
    setValue(String(field?.value || ''));
  }, [field.value, setValue]);

  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: '6px 0',
      }}
    >
      <input
        css={container}
        type={'text'}
        value={value}
        autoComplete="false"
        placeholder={'주소를 입력해 주세요.'}
        onClick={handleClick}
        onBlur={field.onBlur}
        name={name}
        ref={field.ref}
        readOnly
      />
      {errors[name] ? (
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => <p css={errorMessage}>{message}</p>}
        />
      ) : (
        <div css={{ height: '22px' }} />
      )}
    </div>
  );
};

export default Postcode;

const container = css`
  display: flex;
  width: calc(100% - 40px);
  height: 36px;
  border-radius: 5px;
  border: 1px solid ${palette.gray3};
  padding: 0 10px;
  background-color: ${palette.white};
  position: relative;
  :focus {
    outline: none;
  }
  &[readOnly] {
    background-color: ${palette.gray1};
    color: ${palette.gray6};
  }
`;

const errorMessage = css`
  color: ${palette.colorDanger};
  font-size: 12px;
  padding: 3px 5px;
  height: 22px;
`;
